// src/redux/slice/tanProfilesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const displaySlice = createSlice({
  name: 'displaySlice',
  initialState: {
    // Responsive layout is now CSS-driven (see src/styles/_breakpoints.scss and
    // useBreakpoint). This slice only tracks the mobile drawer's open state.
    sidebar: {
      open: false
    }
  },
  reducers: {
    setSidebarOpen: (state, action) => {
      state.sidebar.open = action.payload;
    },
  },
});

export const { setSidebarOpen } = displaySlice.actions;
export default displaySlice.reducer;
